import { CertificateType } from '../shared/enums/CertificateType';
import { Owner } from './Owner.model';
export class LegalCertificateSearch {

    _id: string = "";
    name: string;
    startDate: string;
    endDate: string;
    type: CertificateType[] = [];
    observation: "";
    owner: Owner[];
    notificationsDays: Number = 30
    renovationDate: string = "";
    position: string = "";
    skip: number = 0;
    limit: number = 10;
    totalItems: number = 0;
    totalValue:number = 0;

}



// WEBPACK FOOTER //
// ./src/app/models/legalCertificate.search.model.ts